import API from "./api";
import store from "../store/";

function getBits() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/bits/${channelId}`;
  return API.get(url);
}

function resetBits() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/bits/${channelId}`;
  return API.delete(url);
}

function getProducts() {
  var products = [];
  window.Twitch.ext.bits.getProducts().then(resp => {
    this.produts = resp;
  });
  return products;
}

function purchase(sku) {
  window.Twitch.ext.bits.useBits(sku);
}

function showBalance() {
  window.Twitch.ext.bits.showBitsBalance();
}

function useDummyPurchases() {
  return window.Twitch.ext.bits.setUseLoopback;
}

export default {
  getBits,
  resetBits,
  getProducts,
  purchase,
  showBalance,
  useDummyPurchases
};
